// import { Timestamp } from "@firebase/firestore-types";

import Model from "./Model";

// TODO: Eventually this should be a typescript file, so we can use types and auto-complete

/**
 * @typedef {Object} ItemModel
 *
 * @property {string} id
 *
 * @property {string} added_by - The id of the user who added the profile
 * @property {Timestamp} date_added
 * @property {string} edited_by - The id of the user who edited the profile
 * @property {Timestamp} date_modified
 *
 * @property {String} title
 */
class ItemModel extends Model {
    static table = "collectionCharacteristics";
    static subtables = ["models", "list"];

    static fieldAddedBy = "added_by";
    static fieldAddedDate = "date_added";
    static fieldEditedBy = "edited_by";
    static fieldEditedDate = "date_modified";

    constructor() {
        super();

        this.id = null;

        this.added_by = null;
        this.date_added = null; // TODO: This should be a Timestamp object
        this.edited_by = null;
        this.date_modified = null; // TODO: This should be a Timestamp object

        this.title = null;
    }
}

export default ItemModel;
